import "./cpo_list_detail.scss";

import * as Cpo from "../redux";
import * as _ from "lodash";

import AsyncSelect from "react-select/async";
import { Badge } from "reactstrap";
import { Button } from "zina-dogi-react";
import DatePicker from "react-datepicker/es";
import History from "./history.component";
import PropTypes from "prop-types";
import React from "react";
import TCCUpdateModal from "./tcc_update_modal.component";
import { connect } from "react-redux";
import swal from "sweetalert";
import { utils } from "~/utils";

const COLORSTATUS = status => {
    switch (status) {
        case "cancelled":
            return "danger";
        case "new":
            return "primary";
        case "non_oet_related":
            return "warning";
        default:
            return "success";
    }
};

class CpoListDetail extends React.Component {
    static propTypes = {
        cpo: PropTypes.object,
        onStartOET: PropTypes.func
    };

    state = {
        cancelingCPO: false,
        nonOetRelatedProcess: false,
        blank_oet_received_date: null,
        cpo_effective_to_date: null,
        download_loading: false,
        file_name: null, 
    };

    componentDidMount() {
        const header = (
            <nav className="navbar">
                <span className="navbar-brand h4">Basic Information</span>
            </nav>
        );
        this.props.setheader(header);
    }

    handleChange = date => {
        this.setState({ blank_oet_received_date: date });
    };
    
    handleEffectiveToDateChange = date => {
        this.setState({
            cpo_effective_to_date: date
        })
    }

    get_blank_oet_received_date = () => {
        const { cpo } = this.props;
        const { cpo_register } = cpo;
        let blank_oet_received_date = null;
        if (cpo_register) {
            blank_oet_received_date = this.state.blank_oet_received_date
                ? this.state.blank_oet_received_date
                : utils.strToDate(cpo_register.blank_oet_received_date);
        }
        return blank_oet_received_date;
    };

    get_cpo_effective_to_date = () =>{
        const {cpo_register} = this.props.cpo
        let cpo_effective_to_date = null;
        if(cpo_register){
            cpo_effective_to_date = this.state.cpo_effective_to_date 
                    ? this.state.cpo_effective_to_date 
                    : utils.strToDateTime(cpo_register.effective_to_date)
            
        }
        return cpo_effective_to_date
    }

    render() {
        const { className, cpo, user } = this.props;
        const { cpo_register } = cpo;
        let blank_oet_received_date = this.get_blank_oet_received_date();
        let cpo_effective_to_date = this.get_cpo_effective_to_date();
        if (this.refs.circle && cpo_register) {
            if (cpo_register.circle !== this.refs.circle.select.state.inputValue) {
                this.refs.circle.select.setState({
                    inputValue: cpo_register.circle ? cpo_register.circle : "",
                    value: cpo_register.circle
                });
            }
        }

        const hasOet = cpo && cpo.oet && !Array.isArray(cpo.oet);
        const isFinanceDataFull = !!(
            hasOet &&
            cpo.oet.for_offer_number_created_in_csp &&
            cpo.oet.quantity_contract_number &&
            cpo.oet.sap_top_wbs
        );
        return (
            <div {...{ className: ["cpo_list_detail", className].join(" ") }}>
                <div className="content">
                    <div className="row">
                        <div className="col-md-9">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">Status</th>
                                        <td>
                                            {cpo_register && (
                                                <React.Fragment>
                                                    <Badge
                                                        className="text-white"
                                                        color={COLORSTATUS(cpo_register.status)}
                                                        style={{ fontSize: "1em" }}
                                                    >
                                                        {cpo_register.status_display}
                                                    </Badge>
                                                    {cpo_register && cpo_register.list_type_flow && cpo_register.list_type_flow.map((item) => {
                                                        return (
                                                            <Badge className="text-white" style={{fontSize: "1em", marginLeft: "8px"}}>
                                                                {`${_.upperCase(item)} Process`}
                                                            </Badge>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th scope="col">Customer</th>
                                        <td>{cpo.customer}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">CPO Number</th>
                                        <td>{cpo.number}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">CPO Complete Name</th>
                                        <td>{cpo.prefix}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Provider</th>
                                        <td>{cpo.provider_name}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">PAN Number</th>
                                        <td>{cpo.customer_cnpj}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">CPO Date</th>
                                        <td>{utils.renderDate(cpo.date)}</td>
                                    </tr>
                                    {/* <tr>
                                        <th scope="col">CPO Effective Date</th>
                                        <td>{cpo.extra_fields && utils.renderDate(cpo.extra_fields.effective_date)}</td>
                                    </tr> */}
                                    {cpo_register && user.is_superuser &&(
                                        <tr>
                                            <th scope="col">CPO effective to date</th>
                                            <td className="editable">
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    name="cpo_effective_to_date"
                                                    className="form-control"
                                                    onChange={this.handleEffectiveToDateChange}
                                                    selected={cpo_effective_to_date}
                                                />
                                            </td>
                                        </tr>
                                    )}
                                    <tr>
                                        <th scope="col" title="CPO Expire Date">
                                            CPO Effective to Date
                                        </th>
                                        <td title="CPO Expire Date">
                                            {cpo.extra_fields && utils.renderDate(cpo.extra_fields.effective_to_date)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">CPO Receipt Date</th>
                                        <td>{utils.renderDate(cpo.creation_date)}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Currency</th>
                                        <td>{cpo.currency}</td>
                                    </tr>
                                    {cpo.extra_fields && cpo.extra_fields.quantity_contract_number && (
                                        <tr>
                                            <th scope="col">Quantity Contract Number</th>
                                            <td>{cpo.extra_fields.quantity_contract_number}</td>
                                        </tr>
                                    )}
                                    {cpo_register ? (
                                        <tr>
                                            <th scope="col">Project</th>
                                            <td className="editable">
                                                {this.renderInput("project", cpo_register.project)}
                                            </td>
                                        </tr>
                                    ) : null}
                                    {cpo_register && (
                                        <tr>
                                            <th scope="col">Blank OET received date</th>
                                            <td className="editable">
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    name="blank_oet_received_date"
                                                    className="form-control"
                                                    onChange={this.handleChange}
                                                    selected={blank_oet_received_date}
                                                />
                                            </td>
                                        </tr>
                                    )}
                                    {cpo_register && (
                                                <React.Fragment>
                                        <tr>
                                            <th scope="col">Circle</th>
                                            <td>
                                                <AsyncSelect
                                                    ref="circle"
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions
                                                    defaultInputValue={cpo_register.circle ? cpo_register.circle : ""}
                                                    defaultValue={
                                                        cpo_register.circle
                                                            ? {
                                                                  label: cpo_register.circle,
                                                                  value: cpo_register.circle
                                                              }
                                                            : {
                                                                  label: "",
                                                                  value: ""
                                                              }
                                                    }
                                                    loadOptions={val => this.filterVal(val)}
                                                />
                                            </td>
                                        </tr>
                                        { (cpo_register.gst_number || cpo_register.isd_number || cpo.stp_number) && (
                                        <React.Fragment>

                                            <tr>
                                                <th scope="col">CPO circle</th>
                                                <td>{cpo.circle}</td>
                                            </tr>
                                            <tr>
                                                <th scope="col">GST number</th>
                                                <td>{cpo_register.gst_number}</td>
                                            </tr>
                                            <tr>
                                                <th scope="col">ISD number</th>
                                                <td>{cpo_register.isd_number}</td>
                                            </tr>
                                            <tr>
                                                <th scope="col">STP number</th>
                                                <td>{cpo.stp_number}</td>
                                            </tr>
                                        </React.Fragment>

                                        )
                                            
                                            }
                                        
                                        </React.Fragment>
                                    )}
                                    <tr>
                                        <th scope="col">Version</th>
                                        <td>{cpo.extra_fields && cpo.extra_fields.review_version}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Value</th>
                                        <td>{cpo.total_gross_value_on_file}</td>
                                    </tr>
                                </thead>
                            </table>
                            <div className="controls">
                                <TCCUpdateModal onSubmit={this.saveFinanceData} />
                                <Button color="primary" icon="save" onClick={this.onChangePC}>
                                    Save Changes
                                </Button>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="cpo-sidebar">
                                <div className="cpo-controls">
                                    {this.getStartButton()}
                                    {cpo.cpo_register && cpo.cpo_register.status === "cancelled" && (
                                        <Button
                                            color="success"
                                            style={{ color: "#fff" }}
                                            className="col"
                                            icon="cog"
                                            onClick={this.confirmReOpen}
                                        >
                                            Re-Open
                                        </Button>
                                    )}
                                    <Button
                                        color="warning"
                                        style={{ color: "#fff" }}
                                        className="col"
                                        icon="cog"
                                        onClick={this.reParse}
                                    >
                                        Re-parse file
                                    </Button>
                                    {cpo.cpo_register && cpo.cpo_register.status === "new" && (
                                        <React.Fragment>
                                            <Button
                                                color="warning"
                                                className="col"
                                                icon="cog"
                                                style={{ color: "#fff" }}
                                                onClick={this.nonOetRelated}
                                                disabled={this.state.nonOetRelatedProcess}
                                            >
                                                Non Oet Related
                                            </Button>
                                            <Button
                                                color="primary"
                                                className="col"
                                                icon="cog"
                                                style={{ color: "#fff" }}
                                                onClick={this.props.changeTypeFlow}
                                            >
                                                {`Change to ${
                                                    cpo_register.type_flow === "sode" ? "SODE BULK" : "SODE"
                                                } Process`}
                                            </Button>
                                        </React.Fragment>
                                    )}
                                    <Button color="primary" className="col" icon="download" onClick={this.download}>
                                        Download CPO
                                    </Button>
                                    { cpo_register && cpo_register.expired_days < 90 && cpo_register.expired_days > 60 && !hasOet &&(
                                        <Button color="primary" className="col" icon="upload" onClick={this.open_modal}>
                                            Upload Offline approval
                                        </Button>
                                    )}
                                    {cpo.cpo_register && cpo.cpo_register.status !== "cancelled" ? (
                                        <Button
                                            className="col"
                                            color="danger"
                                            icon="times-circle"
                                            onClick={this.confirmCancel}
                                            disabled={this.state.cancelingCPO}
                                        >
                                            Cancel
                                        </Button>
                                    ) : null}
                                    {cpo.cpo_item_importer_was_done && !isFinanceDataFull && (
                                        <Button
                                            className="col"
                                            color="warning"
                                            icon="clock"
                                            style={{ color: "#fff" }}
                                            onClick={this.sendActionPending}
                                        >
                                            Action Pending
                                        </Button>
                                    )}
                                </div>
                                <div className="history-list">
                                    {cpo.historys &&
                                        cpo.historys.reverse().map((history, index) => (
                                            <History key={`history_${index}`} history={history} />
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getStartButton = () => {
        const { cpo } = this.props;
        const hasOet = cpo && cpo.oet && !Array.isArray(cpo.oet);
        const isTemporary = hasOet && cpo.oet.temporary;
        const isFinanceDataFull = !!(
            hasOet &&
            cpo.oet.for_offer_number_created_in_csp &&
            cpo.oet.quantity_contract_number &&
            cpo.oet.sap_top_wbs
        );
        const button = (
            <React.Fragment>
                {cpo.cpo_register &&
                    !(cpo.cpo_register.status === "non_oet_related" || cpo.cpo_register.status === "cancelled") && (
                        <Button className="col" color="success" icon="play-circle" onClick={this.onStartOET}>
                            {hasOet ? (isTemporary ? "Start OET" : "Go to OET") : "Start OET"}
                        </Button>
                    )}
            </React.Fragment>
        );
        if (!hasOet) {
            if (cpo.cpo_item_importer_was_done) {
                return null;
            }
            return button;
        } else {
            if (isTemporary) {
                if (isFinanceDataFull) {
                    return button;
                }
                return null;
            } else {
                return button;
            }
        }
    };

    saveFinanceData = (values, fns) => {
        const { cpo, update } = this.props;
        if (cpo && cpo.cpo_register) {
            Cpo.service
                .updateTcc(cpo.cpo_register.id, values)
                .then(response => {
                    update();
                    swal({
                        title: "Successfully!",
                        text: "Data Saved",
                        icon: "success",
                        timer: 3000,
                        button: true
                    });
                })
                .catch(error => {
                    if (error && error.response) {
                        const { response } = error;
                        if (response.status === 400) {
                            if (response.data.detail) {
                                swal({
                                    title: "Warning!",
                                    text: response.data.detail,
                                    icon: "warning",
                                    timer: 3000,
                                    button: true
                                });
                            } else {
                                swal({
                                    title: "Warning!",
                                    text: `The fields ${Object.keys(response.data)
                                        .map(key => key.replace(/_/g, " "))
                                        .join(", ")
                                        .replace(/,([^,]*)$/, `and $1`)} are mandatory`,
                                    icon: "warning",
                                    button: true
                                });
                            }
                        }
                    } else {
                        console.log({ ...error });
                    }
                });
        }
    };

    sendActionPending = () => {
        const { cpo, update } = this.props;
        if (cpo && cpo.cpo_register) {
            Cpo.service
                .sendNotificationPending(cpo.cpo_register.id)
                .then(response => {
                    if (response.hasOwnProperty("ok") && response.ok === true) {
                        update();
                        swal({
                            title: "Successfully!",
                            text: `Pending action notification sent`,
                            icon: "success",
                            timer: 3000,
                            button: true
                        });
                    }
                })
                .catch(error => {
                    if (error && error.response) {
                        const { response } = error;
                        if (response.status === 400) {
                            swal({
                                title: "Warning!",
                                text: response.data.detail,
                                icon: "warning",
                                timer: 3000,
                                button: true
                            });
                        }
                    }
                });
        }
    };

    filterVal = val => {
        return this.props.listCircles(val);
    };

    renderInput = (id, defaultValue) => {
        const input = document.querySelector(`#${id}`);
        defaultValue = defaultValue || "";
        if (input) input.value = defaultValue;
        return <input id={id} type="text" autoComplete="off" defaultValue={defaultValue} />;
    };

    onStartOET = ev => {
        const { onStartOET, update } = this.props;
        let circle = this.refs.circle.select.state.value;
        circle = circle ? circle.value : "";
        const project = document.querySelector("#project").value;
        const stp_number = this.props.cpo.stp_number
        onStartOET(project, circle, stp_number);
        update();
    };

    download = ev => {
        const { id } = this.props.cpo;
        Cpo.service.download(id);
    };

    onChangePC = () => {
        const { cpo, savePC } = this.props;
        let circle = this.refs.circle.select.state.value;
        let blank_oet_received_date = utils.dateToStr(this.get_blank_oet_received_date());
        let cpo_effective_to_date = this.get_cpo_effective_to_date()
        if (cpo_effective_to_date){
            cpo_effective_to_date = utils.dateToStr(this.get_cpo_effective_to_date()) + ' 00:00';
        }
        circle = circle ? circle.value : "";
        const project = document.querySelector("#project").value;
        let callback_function = cpo_register => {
            swal({
                title: "Successfully updated!",
                text: `CPO ${cpo.prefix}`,
                icon: "success",
                timer: 3000,
                button: true
            });
        };
        savePC(cpo.cpo_register.id, circle, project, cpo_effective_to_date, blank_oet_received_date, callback_function);
    };

    reParse = ev => {
        const { file_parser } = this.props.cpo;
        Cpo.service
            .reParseCpoFile([file_parser])
            .then(result => {
                swal({
                    title: "Sent to queue",
                    text: "This customer purchase order has been sent to be reparsed",
                    icon: "success",
                    timer: 3000,
                    button: true
                });
            })
            .catch(errr => {
                swal({
                    title: "Warning ...",
                    text: "Something has gone wrong",
                    icon: "warning",
                    timer: 3000,
                    button: true
                });
            });
    };

    confirmCancel = ev => {
        swal({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            buttons: {
                cancel_cpo: {
                    visible: true,
                    text: "Yes, proceed",
                    value: true,
                    className: "btn btn-danger"
                },
                back: {
                    visible: true,
                    text: "Cancel, go back",
                    value: false,
                    className: "btn btn-primary"
                }
            }
        }).then(result => {
            if (result) {
                this.cancel(ev).catch(error => {
                    swal({
                        title: "Error",
                        text: utils.computeError(error),
                        icon: "warning",
                        timer: 3000,
                        button: true
                    });
                });
            }
        });
    };

    confirmReOpen = ev => {
        swal({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "info",
            buttons: {
                yes_re_open: {
                    visible: true,
                    text: "Yes, proceed",
                    value: true,
                    className: "btn btn-success"
                },
                no_re_open: {
                    visible: true,
                    text: "Cancel",
                    value: false,
                    className: "btn btn-primary"
                }
            }
        }).then(result => {
            if (result) {
                this.props.reOpenCPO(this.props.cpo.cpo_register.id);
            }
        });
    };

    cancel = ev => {
        return this.props.cancelCPO(this.props.cpo.id, this.props.cpo.number);
    };

    nonOetRelated = ev => {
        this.setState({ nonOetRelatedProcess: true });
        const { cpo, onMarkAsNonOetRelated } = this.props;
        onMarkAsNonOetRelated(
            cpo.id,
            cpo.number,
            () =>
                swal({
                    title: "The customer purchase order has been marked as non oet related successfully.",
                    icon: "success"
                }),
            () => this.setState({ nonOetRelatedProcess: false })
        );
    };
}

const mapDispatchToProps = dispatch => ({
    cancelCPO: (cpoID, cpoNumber) => dispatch(Cpo.actions.cancelCPO(cpoID, cpoNumber)),
    reOpenCPO: cpoID => dispatch(Cpo.actions.reOpenCPO(cpoID)),
    savePC: (cpo_id, circle, project, cpo_effective_to_date, blank_oet_received_date, cb) =>
        dispatch(Cpo.actions.updateCPO(cpo_id, circle, project,cpo_effective_to_date, blank_oet_received_date, cb )),
    sendFile: data => dispatch(Cpo.actions.sendFile(data))
});

export default connect(null, mapDispatchToProps)(CpoListDetail);
